import { render, staticRenderFns } from "./NewDownloadCategoryPage.vue?vue&type=template&id=79adaf5a&"
import script from "./NewDownloadCategoryPage.vue?vue&type=script&lang=js&"
export * from "./NewDownloadCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports